module.exports = __webpack_public_path__ + "pc-top-assets/img/ufj.4cb41b38.png";